module.exports = __webpack_public_path__ + "img/2.bc8e0476.png";